export default function AudioVisualizer({
  frequencyData,
  brandHSLAString,
}: {
  brandHSLAString: string;
  frequencyData: Uint8Array;
}) {
  const getBarHeight = (value: number, index: number, totalBars: number) => {
    const centerIndex = Math.floor(totalBars / 2);
    const distanceFromCenter = Math.abs(index - centerIndex);
    const centerEmphasis = 1 - distanceFromCenter / centerIndex;
    return Math.max((value / 255) * 100 * centerEmphasis, 5); // Minimum height of 5%
  };

  return (
    <div className="flex items-center justify-center space-x-1 w-full max-w-[50px] rounded-lg h-[36px] bg-transparent overflow-hidden">
      {Array.from(frequencyData).map((value, index) => {
        const height = getBarHeight(value, index, frequencyData.length);
        return (
          <div
            key={index}
            className="flex flex-col shrink-0 justify-center h-full"
            style={{
              width: "2px",
            }}
          >
            <div
              className="self-center"
              style={{
                height: `${height}%`,
                background: brandHSLAString,
                width: "100%",
                transition: "height 150ms ease",
                transform: "scaleY(2)",
                transformOrigin: "center",
              }}
            />
          </div>
        );
      })}
    </div>
  );
}
